// Routes that are safe to request even when no/expired auth token exists.
// Used by axiosInstance (see src/network/adapter.js) to avoid redirecting to login on 401.
export const PublicRoutes = ['/terms-and-conditions']

export function isGuestQmsPage() {
  if (typeof window === 'undefined') return false
  if (window.location.pathname !== '/qms/create-qms') return false
  const params = new URLSearchParams(window.location.search)
  return Boolean(
    params.get('guestDraft') || window.localStorage.getItem('oujat-guest-qms-token')
  )
}